import { Box, ContextMenuItem, Text } from '@modusign/design-system';

interface ItemProps {
  title: string;
  example: string;
  onClick: () => void;
}

export function FormatContextMenuItem({ title, example, onClick }: ItemProps) {
  return (
    <ContextMenuItem onClick={onClick}>
      <Text color="textNeutralSlightlyLight" fontSize="md" fontWeight="regular">
        {title}
      </Text>
      <Box mt={2}>
        <Text color="textNeutralVeryLight" fontSize="md" fontWeight="regular">
          {example}
        </Text>
      </Box>
    </ContextMenuItem>
  );
}
